import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { SkipNext } from "@mui/icons-material";
import PauseRoundedIcon from "@mui/icons-material/PauseRounded";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import { Box, Slide, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material";

import constants from "../../../assets/constants";
import OmniEditButton from "../../ui/omniEditButton";
import Widget from "../../ui/widget";
import WidgetContent from "../../ui/widgetContent";
import WidgetTitle from "../../ui/widgetTitle";

const TopicImages = props => {
  const { images, interval, theme, isPlaying } = props;
  const imageTimerRef = useRef(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [slideIn, setSlideIn] = useState(true);
  const [slideDirection, setSlideDirection] = useState("left");

  const largeScreen = useMediaQuery(theme => theme.breakpoints.up("lg"));

  const goNext = imageCount => {
    setSlideDirection("right");
    setSlideIn(false);
    let timer = setTimeout(() => {
      setCurrentImageIndex(prevIndex => (prevIndex + 1) % imageCount);
      setSlideDirection("left");
      setSlideIn(true);
      clearTimeout(timer);
    }, 500);
  };

  // const goPrev = imageCount => {
  //   setSlideDirection("left");
  //   setSlideIn(false);
  //   let timer = setTimeout(() => {
  //     setCurrentImageIndex(prevIndex => (prevIndex - 1 + imageCount) % imageCount);
  //     setSlideDirection("right");
  //     setSlideIn(true);
  //     clearTimeout(timer);
  //   }, 500);
  // };

  useEffect(() => {
    if (isPlaying) {
      imageTimerRef.current = setInterval(() => {
        goNext(images.length);
      }, interval);
    } else {
      return () => clearInterval(imageTimerRef.current);
    }
    return () => clearInterval(imageTimerRef.current);
  }, [images, interval, isPlaying]);

  // useEffect(() => {
  //   if (next) {
  //     goNext(images.length);
  //     setNext(false);
  //   }
  // }, [images, next, setNext]);

  // useEffect(() => {
  //   if (prev) {
  //     goPrev(images.length);
  //     setPrev(false);
  //   }
  // }, [images, prev, setPrev]);

  useEffect(() => {
    if (currentImageIndex === images.length - 1 && isPlaying) {
      setTimeout(() => {
        clearTimeout();
      }, interval - 500);
    }
  }, [images, interval, currentImageIndex, isPlaying]);

  return (
    <Box sx={{ margin: theme.spacing(2) }}>
      {images.map((src, index) => (
        <Slide
          direction={slideDirection}
          in={slideIn && index === currentImageIndex}
          timeout={500}
          mountOnEnter
          unmountOnExit
          key={index}
          sx={{ height: "100%", width: "100%" }}
        >
          <img
            component="img"
            src={src}
            alt={`Slide ${index}`}
            height={largeScreen ? "100%" : "auto"}
            width={largeScreen ? "auto" : "100%"}
            sx={{ objectFit: "contain" }}
          />
        </Slide>
      ))}
    </Box>
  );
};

const Topic = props => {
  const { topic, interval, theme, isPlaying } = props;

  const [slideDirection] = useState("left");

  return (
    <Box sx={{ margin: theme.spacing(2) }}>
      <Slide direction={slideDirection} in={topic} timeout={500} mountOnEnter unmountOnExit>
        <Box key={topic.id}>
          <TopicImages
            theme={theme}
            images={topic.imageLinks}
            interval={interval}
            isPlaying={isPlaying}
          />
        </Box>
      </Slide>
    </Box>
  );
};

const EmpireInformation = props => {
  const topics = constants.empireUserToDosLearningTopics;
  const interval = 5000;
  const theme = useTheme();
  const [isPlaying, setIsPlaying] = useState(true);
  const [titleText, setTitleText] = useState("Loading...");
  const [topicIndex, setTopicIndex] = useState(topics && topics.length > 0 ? 0 : -1);

  useEffect(() => {
    if (topics && topicIndex >= 0) {
      setTitleText(topics[topicIndex].title);
    }
  }, [topics, topicIndex]);

  return (
    <Widget>
      <WidgetTitle title={"Learning"} text={titleText}>
        <Box sx={{ position: "relative" }}>
          <OmniEditButton
            sx={{
              top: 0,
              color: theme.palette.secondary.main,
              backgroundColor: theme.palette.primary.main,
            }}
            title={"Next"}
            icon={<SkipNext />}
            onClick={() => {
              setIsPlaying(true);
              setTopicIndex(prevIndex => (prevIndex + 1 >= topics.length ? 0 : prevIndex + 1));
            }}
          />

          <OmniEditButton
            sx={{
              top: 0,
              right: "48px",
              color: theme.palette.secondary.main,
              backgroundColor: theme.palette.primary.main,
            }}
            title={isPlaying ? "Pause" : "Play"}
            icon={isPlaying ? <PauseRoundedIcon /> : <PlayArrowRoundedIcon />}
            onClick={() => {
              setIsPlaying(prevState => !prevState);
            }}
          />

          {/* <OmniEditButton
            sx={{
              top: 0,
              right: "92px",
              color: theme.palette.secondary.main,
              backgroundColor: theme.palette.primary.main,
            }}
            title={"Previous"}
            icon={<PreviousIcon />}
            onClick={() => {
              setTopicIndex(prevIndex => (prevIndex - 1 >= 0 ? prevIndex - 1 : topics.length - 1));
            }}
          /> */}
        </Box>
      </WidgetTitle>
      <WidgetContent justifyContent={"flex-start"}>
        {topics && topicIndex >= 0 && (
          <Topic
            topic={topics[topicIndex]}
            theme={theme}
            interval={interval}
            isPlaying={isPlaying}
          />
        )}
      </WidgetContent>
    </Widget>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EmpireInformation));
